import * as React from "react";


import { Grid, CardMedia } from "@mui/material";
import PodcastsIcon from "@mui/icons-material/Podcasts";
import WalletIcon from "@mui/icons-material/Wallet";
import FirstImage from "../../images/3691910.jpg";
import SecondImage from "../../images/6048753.jpg";



import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { useTranslation } from "react-i18next";
import enTranslations from "../../en.json";
import arTranslations from "../../ar.json";


i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    ar: { translation: arTranslations },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default function PodcastAndBudget(props) {
  const { t } = useTranslation();
  return (
    <Grid container spacing={0}>
      <Grid item xs={12} md={6} sx={{ m: 0, borderRadius: 50 }}>
        <div className="introduction">
          <CardMedia
            component="img"
            sx={{ width: "100%", height: "100%" }}
            image={FirstImage}
            alt="we help you"
          />
        </div>
      </Grid>
      <Grid item xs={12} md={6} sx={{ m: 0, borderRadius: 50 }}>
        <div className="introduction">
          <h2 className="title12">{t("joinourpodcasts")} </h2>
          <p className="paragraph">{t("paragraph1")}</p>
          <props.PrincipaleButton
            startIcon={<PodcastsIcon />}
            variant="contained"
            href="/signup"
          >
            {t("subscribe")}
          </props.PrincipaleButton>
        </div>
      </Grid>
      <Grid item xs={12} md={6} sx={{ m: 0, borderRadius: 50 }}>
        <div className="introduction">
          <CardMedia
            component="img"
            sx={{ width: "100%", height: "100%" }}
            image={SecondImage}
            alt="we help you"
          />
        </div>
      </Grid>
      <Grid item xs={12} md={6} sx={{ m: 0, borderRadius: 50 }}>
        <div className="introduction">
          <h1 className="title12">{t("setyourbudget")}</h1>
          <p className="paragraph">{t("paragraph2")}</p>
          <props.PrincipaleButton
            startIcon={<WalletIcon />}
            variant="contained"
            href="/signup"
          >
            {t("subscribe")}
          </props.PrincipaleButton>
        </div>
      </Grid>
    </Grid>
  );
}
